import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  /* display: flex; */
  /* justify-content: center; */
`;

export const ImageStyled = styled.img`
  width: 40%;
  max-width: 100%;
`;
